export const skills = {
    frontend: ['React', 'Redux', 'TypeScript', 'JS', 'CSS', 'HTML'],
    backend: ['Node.js', 'Express', 'GraphQL', 'MongoDB', 'SQL'],
    languages: ['Python', 'bash', 'Java'],
    other: ['Linux environment', 'ESLint', 'Git',  'LaTeX'] 
}


export const resumeData = [

    {
        title: 'Full Stack Development course | Full Stack open',
        location: 'Helsinki University (remote), Finland',
        content: [
            'Online course from University of Helsinki', 
            '• Introduction to modern JavaScript-based web development',
            '• Focus on building single page applications with ReactJS that use REST APIs built with Node.js',
            '• Debugging application, container technology,  configuration, managing runtime environments, databases'],
        date: 'June 2023 - now',
        tags: ['Training'],
        link: {
            url:
                'https://fullstackopen.com/',
            text: 'See the FullStack course'
        },
        id: 'Fullstack Open'
    },
    {
        title: 'Finnish courses',
        location: 'Tampere, Finland',
        content: ['Onnenkieli Oy. 84h'],
        date: 'Jan - May 2023',
        tags: ['Suomi'],
        id: 'Onnenkieli'
    },
    {
        title: 'PhD in Bioinformatics',
        location: 'University of Rennes 1, Irisa. France',
        content: [
            'Developing algorithms applied on genetic datasets',
            '• Data analysis, programming, teaching (python programming, algorithmic, statistics, introduction to programming for secondary school girls)', 
            '• Scientific publication',
            '• Popularization of science: participation (2020) and organization (2021) of a festival of popularization of science, short movies made by PhD students'
        ],
        date: 'Oct. 2019 - Dec. 2022',
        tags: ['Education', 'Work'],

        link: {
            url:
                ' https://doi.org/10.1371/journal.pone.0257521',
            text: 'See publication'
        },
        id: 'PhD'
    },
    {
        title: 'Master\'s internship in Bioinformatics',
        location: 'Inria, Rennes. France',
        content: ['Analysis of genomic sequences to infer errors during data generation'],
        date: '2019 (6 months)',
        tags: ['Work'],
        id: 'Stage M2'
    },
    {
        title: 'Master\'s internship in Bioinformatics',
        location: 'INRA, Rennes. France',
        content: [
            '• Integrate and request datasets obtained from different technologies and fields',
            '• Contribution to a publication'
        ],
        date: '2018 (4 months)',
        tags: ['Work'],
        link: {
            url:
                'https://doi.org/10.1371/journal.pgen.1007593',
            text: 'See publication contribution'
        },
        id: 'Stage M1'
    },
    {
        title: 'Master\'s degree in Bioinformatics',
        location: 'University of Rennes 1, France',
        content: [
            'Programming, linux environment, databases, biological systems modeling, statistics linear programming optimization, genomic data analysis'
        ],
        date: '2017 - 2019',
        tags: ['Education'],
        id: 'Master bioinfo'
    },
    {
        title: 'Bachelor\'s degree in Biology of organisms',
        location: 'University of Rennes 1, France',
        content: ['Programming, statistics, physiology, animal behavior, population genetics'],
        date: '2016 - 2017',
        tags: ['Education'],
        id: 'L3 bio'
    },
    {
        title: '"Classe préparatoire aux grandes écoles" (Biology)',
        location: 'Rennes, France',
        content: [
            'Two-year intensive preparation courses for the entrance exam to French (veterinarian or agri-food processing) schools.',
            'Biology, mathematics, physics and chemistry, introduction to programming'
        ],
        date: '2014 - 2016',
        tags: ['Education'],
        id: 'prepa'
    },
    
];

